/**
 * Defines the polling intervals (in milliseconds) for various API endpoints.
 *
 * Naming convention:
 * - The interface name should reflect the API it applies to.
 * - The property names should clearly indicate the endpoint they correspond to.
 */
interface PollingInterval {
  megTemplate: MegTemplateApiPollingInterval;
  tmm: TmmApiPollingInterval;
  qa: QAApiPollingInterval;
}

/**
 * Applies to API: avp-avengers-tmm-service-api
 *
 * Used in views: TargetManagerView, TmmEditorView, TmmView
 */
interface TmmApiPollingInterval {
  getIdmmUpdate: number;
  getTargetInfo: number;
  getTmmUpdate: number;
}

/**
 * Applies to API: avp-avengers-megtemplate-service-api
 *
 * Used in views: MegTemplateView
 */
interface MegTemplateApiPollingInterval {
  getTree: number;
  getNodeData: number;
}

interface QAApiPollingInterval {
  getMegPrStringInfo: number;
}

export const pollingInterval: PollingInterval = {
  megTemplate: {
    getTree: 20_000,
    getNodeData: 20_000,
  },
  tmm: {
    getIdmmUpdate: 20_000,
    getTargetInfo: 20_000,
    getTmmUpdate: 20_000,
  },
  qa: {
    getMegPrStringInfo: 5_000,
  },
};
